import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  formErrors: {},
  selectedAssistance: {
    id: 0,
    name: '',
  },
}

const updateAssistanceFormErrorsHandler = (state, action) => {
  state.formErrors = action.payload
}

const updateSelectedAssistanceHandler = (state, action) => {
  state.selectedAssistance = action.payload
}

export const AssistanceSlice = createSlice({
  name: 'assistanceProducts',
  initialState,
  reducers: {
    updateAssistanceFormErrors: updateAssistanceFormErrorsHandler,
    updateSelectedAssistance: updateSelectedAssistanceHandler,
    clearAssistance: () => initialState,
  },
})

export const { updateAssistanceFormErrors, updateSelectedAssistance, clearAssistance } = AssistanceSlice.actions

export default AssistanceSlice.reducer
